module.exports = __webpack_public_path__ + "img/files-and-folder.223ce62a.svg";